import { toast } from "react-toastify";
import axios from "axios";
// Get the current URL path dynamically
const currentPath = window.location.pathname;

export const messages = async (msg, apiStatus) => {
  if (apiStatus === 1) {
    toast.success(msg);
  } else {
    toast.error(msg);
  }
};


// const axiosWithRetry = async (url, options = {}, timeout = 5000, retries = 1) => {
//   for (let attempt = 0; attempt <= retries; attempt++) {
//     try {
//       const res = await axios({
//         url,
//         timeout, // ⏳ fail if > timeout
//         ...options,
//       });
//       return res.data; // ✅ success
//     } catch (err) {
//       console.log("=====>", url, err, )
//       // console.warn(Attempt ${attempt + 1} failed:, err.message);

//       if (attempt === retries) {
//          window.location.replace(`/no-internet?currentUrl=${window.location.pathname + window.location.search + window.location.hash}`)
//       }
//     }
//   }
// };
const axiosWithRetry = async (
  url,
  { method, data, params, headers = {} } = {},
  timeout = 5000,
  retries = 1
) => {
   const token =
    ((localStorage.getItem("slug") === "admin") ||
     (localStorage.getItem("slug") === "checker")) &&
    currentPath?.includes("/admin/")
      ? localStorage.getItem("x-admin-token")
      : localStorage.getItem("x-auth-token");
  const defaultHeaders = {
    "Content-Type": "application/json",
    "x-auth-token": token,
  };
  const mergedHeaders = { ...defaultHeaders, ...headers };

  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const res = await axios({
        url,
        method,      // GET / POST / PUT / DELETE
        data,        // body (only used for POST/PUT/PATCH)
        params,      // query string (?key=value)
        headers: mergedHeaders,     // custom headers if needed
        timeout,     // ⏳ auto-abort after timeout
      });
      return res.data; // ✅ success
    } catch (err) {
      console.log("=====>", method, url, err.message);

      if (attempt === retries) {
        // redirect after final failure
        //window.location.replace(`/no-internet?currentUrl=${window.location.pathname + window.location.search + window.location.hash}`);
      }
    }
  }
};

export const postApi = async (api, method, data, customHeaders = {}) => {
  return await axiosWithRetry(api, { method, data, headers: customHeaders }); // return result properly
};

export const imageCreatePostApi = async (api, type, body) => {
  const res = await fetch(api, {
    method: type,
    headers: {
      "Content-Type": "application/json",
      "x-auth-token": (((localStorage.getItem("slug") === "admin") || (localStorage.getItem("slug") === "checker")) && currentPath?.includes('/admin/')) ? localStorage.getItem("x-admin-token") : localStorage.getItem("x-auth-token"),
    },
    body: JSON.stringify(body),
    // redirect: "follow",
  });
  return await res.json();
};


export const allApi = async (api, method, customHeaders = {}) => {
  return await axiosWithRetry(api, { method, headers: customHeaders }); // return result properly
};

// export const allApi = async (api, type) => {
//   const res = await fetch(api, {
//     method: type,
//     headers: {
//       "Content-Type": "application/json",
//       "x-auth-token": (localStorage.getItem("slug") === "admin" && currentPath?.includes('/admin/')) ? localStorage.getItem("x-admin-token") : localStorage.getItem("x-auth-token"),
//     },
//   });
//   return await res.json();
// };


export const postApiFile = async (api, type, userDetails) => {
  const formData = new FormData();
  Object.entries(userDetails).map(([key, value]) => {
    formData.append(key, value);
  });
  const myHeaders = new Headers();
  myHeaders.append("x-auth-token", (localStorage.getItem("slug") === "admin" && currentPath?.includes('/admin/')) ? localStorage.getItem("x-admin-token") : localStorage.getItem("x-auth-token"));
  const res = await fetch(api, {
    method: type,
    body: formData,
    headers: myHeaders,
  });
  return await res.json();
};

export const multiFileUpload = async (api, type, userDetails) => {
  const formData = new FormData();
  formData.append("product", userDetails?.product);
  formData.append("defaultImage", userDetails?.defaultImage);
  userDetails?.images.forEach((image, index) => {
    formData.append(`images[${index}]`, image);
  });
  const myHeaders = new Headers();
  myHeaders.append("x-auth-token", (localStorage.getItem("slug") === "admin" && currentPath?.includes('/admin/')) ? localStorage.getItem("x-admin-token") : localStorage.getItem("x-auth-token"));
  const res = await fetch(api, {
    method: type,
    body: formData,
    headers: myHeaders,
  });
  return await res.json();
};

export const multipleImages = async (api, type, userDetails) => {
  const formData = new FormData();
  Object.entries(userDetails).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item === 'object' && item !== null) {
          formData.append(`${key}[]`, item); 
        }
      });
    } else {
      formData.append(key, value);
    }
  });
  const myHeaders = new Headers();
  myHeaders.append("x-auth-token", (localStorage.getItem("slug") === "admin" && currentPath?.includes('/admin/')) ? localStorage.getItem("x-admin-token") : localStorage.getItem("x-auth-token"));
  const res = await fetch(api, {
    method: type,
    body: formData,
    headers: myHeaders,
  });
  return await res.json();
};


export const fileWithObjArray = async (api, type, userDetails) => {
  const formData = new FormData();
  Object.entries(userDetails).map(([key, value]) => {
    formData.append(key, value);
  });
  const myHeaders = new Headers();
  myHeaders.append("x-auth-token", (localStorage.getItem("slug") === "admin" && currentPath?.includes('/admin/')) ? localStorage.getItem("x-admin-token") : localStorage.getItem("x-auth-token"));
  const res = await fetch(api, {
    method: type,
    body: formData,
    headers: myHeaders,
  });
  return await res.json();
};
